import { localDate } from "./format";

/** A calendar file for the due date, for the website (the iPhone app sets a reminder instead). */
export function dueDateCalendar(name: string, due: string, link: string, now = new Date()): string | null {
  const d = localDate(due);
  if (!d) return null;
  const ymd = (x: Date) => `${x.getFullYear()}${String(x.getMonth() + 1).padStart(2, "0")}${String(x.getDate()).padStart(2, "0")}`;
  const next = new Date(d);
  next.setDate(d.getDate() + 1);
  const stamp = now.toISOString().replace(/[-:]/g, "").replace(/\.\d+Z$/, "Z");
  // text values escape backslashes, semicolons, commas and newlines (RFC 5545 3.3.11)
  const text = (s: string) => s.replace(/[\\;,]/g, (ch) => `\\${ch}`).replace(/\n/g, "\\n");
  // long lines fold onto continuation lines that start with a space (RFC 5545 3.1)
  const fold = (line: string) => (line.match(/.{1,60}/gu) ?? [""]).join("\r\n ");
  return [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Nameling//Due date//EN",
    "CALSCALE:GREGORIAN",
    "BEGIN:VEVENT",
    `UID:due-${ymd(d)}-${Math.random().toString(36).slice(2, 10)}@nameling`,
    `DTSTAMP:${stamp}`,
    `DTSTART;VALUE=DATE:${ymd(d)}`,
    `DTEND;VALUE=DATE:${ymd(next)}`,
    `SUMMARY:${text(name ? `${name}'s due date` : "Due date")}`,
    `DESCRIPTION:${text(`Whenever you're ready, Nameling can make a card to announce the birth: ${link}`)}`,
    "TRANSP:TRANSPARENT",
    "END:VEVENT",
    "END:VCALENDAR",
    "",
  ]
    .map(fold)
    .join("\r\n");
}
